import * as actions from '../redux/actions';

import CommonSearchBox from '../common/search-box/CommonSearchBox';
import HomeBanners from '../HomeBanners';
import React from 'react';
import ThemeFourContactForm from './common/ThemeFourContactForm';
import ThemeFourIconSection from './common/ThemeFourIconSection';
import ThemeFourImages from './ThemeFourPages/ThemeFourImages';
import ThemeFourSearchBox from './common/ThemeFourSearchBox';
import ThemeFourSlider from './common/ThemeFourSlider';
import ThemeFourTitle from './common/ThemeFourTitle';
import ThemeFourWorkWithUsPage from './ThemeFourPages/ThemeFourWorkWithUsPage';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';

// import CommonService from '../../../services/commonService';

const ThemeFour = ({ history, operator }) => {
	// const operator = CommonService.getLocal('op');

	return (
		<div className="theme-four">
			<div style={{ position: 'relative', marginBottom: '50px' }}>
				<HomeBanners
					slides={getSlides('Banner', operator)}
					height={operator && operator.operator_name === 'santajuana' || operator && operator.operator_name === 'losnavegadores' || operator && operator.operator_name === 'chilebus' ? '' : '63vh'}
					activeDotColor={operator && operator.color_codes && operator.color_codes.tertiary_color}
				/>

				<div className="searchboxoverlay">
					<CommonSearchBox history={history} operator={operator} />
					{/* <ThemeFourSearchBox history={history} operator={operator} /> */}
				</div>
			</div>

			{operator && operator.operator_name === 'santajuana' ? (
				<ThemeFourTitle title="¿Qué nos destaca?" />
			) : (
				<ThemeFourTitle title="¿Qué hacemos?" />
			)}
			<ThemeFourIconSection />

			<ThemeFourTitle title="Descubre nuestros destinos" />
			{/* <ThemeFourSlider slides={getSlides('Destination', operator)} /> */}
			{/* <ThemeFourWorkWithUsPage /> */}

			{operator && operator.operator_name === 'santajuana' ? (
				<ThemeFourImages />
			) : (
				<ThemeFourSlider slides={getSlides('Destination', operator)} />
			)}

			<div className="contact-home-banner">
				<img src={getIcons('ContactBg', operator)} alt="" />
				<div className="contact-home-form">
					<ThemeFourContactForm homeForm />
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFour);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFour.js